import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { FormsModule } from '@angular/forms';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FieldTypeListSimpleComponent } from '../field-type-list/field-type-list-simple/field-type-list-simple.component';
import { FieldTypeTextMultilineComponent } from "../field-type-text/field-type-text-multiline/field-type-text-multiline.component";
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
    selector: 'attach-document-modal',
    templateUrl: './attach-document-modal.component.html',
    standalone: true,
    imports: [FieldTypeListSimpleComponent, AfTranslateDirective, FormsModule, FieldTypeTextMultilineComponent]
})
export class AttachDocumentModalComponent implements OnInit {
  conceptObjectId: any = this.route.snapshot.params['conceptObjectId'];
  item: any = this.dialogConfig.data.item;
  attachDocumentModal:any = {
    comments: '',
    associatedDocuments: '',
    attachDocumentSelectedList: [],
    conceptDocument: {
      label: this.translate.instant('attach-document.stored-documents-concept'),
      required:  true
    },
    addCommentField:{ label: this.translate.instant('attach-document.add-comment') },
    conceptDocumentList: []
  }

  constructor(
    private route: ActivatedRoute,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private dialogRef: DynamicDialogRef<AttachDocumentModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private modalService: ModalServiceService) { }

  ngOnInit(): void {
    this.getConceptDocumentation();
  }

  getConceptDocumentation(){
    this.apiService.get('documentobjects/onlyDB/notintask/'+this.item?.conceptObjectId, this.item.taskId)
      .then((data:any)=>{
        this.attachDocumentModal.conceptDocumentList = this.commonUtilsService.editList(data, 'documentObjectId', 'name');
    })
  }

  itemSelected(e:any, type:any){
    this.attachDocumentModal.conceptDocument.error = false;
    this.attachDocumentModal[type] = e.newValue;
  }

  associateDocuments(){
    if(!this.attachDocumentModal.associatedDocuments || this.attachDocumentModal.associatedDocuments === ''){
      this.attachDocumentModal.conceptDocument.error = true;
      this.modalService.errorModal({ text: this.translate.instant('documentation-list.error-configuration-add-document') });
    }else{
      this.attachDocumentModal.attachDocumentSelectedList = [{
        documentObjectId:  this.attachDocumentModal.associatedDocuments
      }]
      this.handleAccept();
    }
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  };

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      documents: this.attachDocumentModal.attachDocumentSelectedList,
      comments: this.attachDocumentModal.comments
    })
  };

}
